import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface ContactMethod {
  id: string;
  icon: string;
  title: string;
  description: string;
  value: string;
  action: string;
  actionLink: string;
  available: string;
}

interface ContactMethodCardProps {
  method: ContactMethod;
}

const ContactMethodCard = ({ method }: ContactMethodCardProps) => {
  return (
    <div className="bg-card rounded-lg shadow-card hover:shadow-hover transition-all duration-300 p-6 lg:p-8 border border-border">
      <div className="flex items-start space-x-4">
        <div className="flex-shrink-0">
          <div className="w-12 h-12 lg:w-14 lg:h-14 bg-accent/10 rounded-lg flex items-center justify-center">
            <Icon name={method.icon as any} size={24} variant="outline" className="text-accent" />
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-lg lg:text-xl font-heading font-bold text-primary mb-2">
            {method.title}
          </h3>
          <p className="text-sm lg:text-base text-text-secondary mb-4">
            {method.description}
          </p>
          <div className="space-y-3">
            <div className="flex items-center space-x-2">
              <Icon name="ClockIcon" size={16} variant="outline" className="text-text-secondary flex-shrink-0" />
              <span className="text-sm text-text-secondary">{method.available}</span>
            </div>
            <a
              href={method.actionLink}
              className="inline-flex items-center space-x-2 text-accent hover:text-accent/80 font-heading font-semibold text-sm lg:text-base transition-colors duration-300"
            >
              <span>{method.value}</span>
              <Icon name="ArrowRightIcon" size={16} variant="outline" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactMethodCard;